module.exports = __webpack_public_path__ + "static/fb-image-491a212af9fa5a0a70581d206876217c.png";